export enum ItemText {
  CANCEL_YOUR_BOOKING = 'Cancel your booking',
  UPDATE_GUEST_DETAILS = 'Update guest details',
  CHANGE_YOUR_BOOKING = 'Change your booking',
}
